import type { CountedLine } from '@/lib/item-counter'

/**
 * Everything still to be made, in one list. A cook looking at twelve tickets cannot see
 * that nine of them want the same burrito; this is the view that answers that.
 */
export function ItemCounterPanel({ lines, width, rowSize, fullScreen }: { lines: CountedLine[]; width: number; rowSize: number; fullScreen: boolean }) {
  const scale = rowSize / 100
  return (
    <aside className={fullScreen ? 'flex min-h-0 flex-1 flex-col' : 'flex min-h-0 shrink-0 flex-col border-l bg-muted/20'} style={fullScreen ? undefined : { width }} aria-label="Kvar att tillaga">
      <h2 className="border-b px-3 py-2 text-xs font-semibold tracking-wide uppercase">Kvar att tillaga</h2>
      {!lines.length ? (
        <p className="flex flex-1 items-center justify-center p-6 text-center text-sm text-muted-foreground">Inget kvar att tillaga.</p>
      ) : (
        <ul className={fullScreen ? 'grid min-h-0 flex-1 auto-rows-min gap-2 overflow-y-auto p-3 sm:grid-cols-2 lg:grid-cols-3' : 'min-h-0 flex-1 divide-y overflow-y-auto'}>
          {lines.map((line) => (
            <li key={line.name} className={fullScreen ? 'flex items-center gap-3 rounded-xl border bg-card p-3' : 'flex items-center gap-3 px-3 py-2'} style={{ fontSize: `${scale}rem` }}>
              <span className="min-w-[2.2em] shrink-0 text-right text-[1.6em] font-bold tabular-nums">{line.quantity}</span>
              <span className="min-w-0 flex-1 break-words">{line.name}</span>
            </li>
          ))}
        </ul>
      )}
    </aside>
  )
}
